        
        <corp-card [corp-content]="tp_corp_card_summary"></corp-card>

        <ng-template #tp_corp_card_summary>
            <div class="corp-card">
                <div class="corp-card-header mb-[10px] md:mb-[5px] sm:flex items-center justify-between">
                        <h6 class="!mb-0">
                            <!-- i18n: Order Summary -->
                            {{ 'i18n.app.features.pages.order.wizard.step_01.summary.h6_01' | translate }}
                        </h6>
                    <div 
                        class="h-8 w-8 flex items-center justify-center rounded-full bg-primary-500 shadow-lg shadow-primary">
                        <span class="material-symbols-outlined text-sm text-white leading-none">
                            trolley
                        </span>
                    </div>
                </div>

                
                <div class="corp-card-content">
                @if(!_orderWizardService.isFormEmpty()){
                    <div class="table-responsive overflow-x-auto">
                        @if(!_orderWizardService.orderWizard$()?.step01?.pricingSummary?.isAmountAlert){
                            <ng-container [ngTemplateOutlet]="component_summary"></ng-container>
                        }
                        @if(showAlert) {
                            <ng-container [ngTemplateOutlet]="component_alert"></ng-container>
                        }
                    </div>
                }
                @else {
                    <div class="flex items-center justify-center h-40 bg-gray-300 rounded-sm">
                        <h4>
                            <!-- i18n: No information available -->
                            {{ 'i18n.app.features.pages.order.wizard.step_01.summary.h4_01' | translate }}
                        </h4>
                    </div>
                }
                </div>
            </div>
        </ng-template>


    <!-- TEMPLATE -->
    <ng-template #component_summary>
        <order-purchase-summary-table></order-purchase-summary-table>
    </ng-template>

    <ng-template #component_alert>
        <order-purchase-summary-alert ></order-purchase-summary-alert>
    </ng-template>